import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SceneLauncherComponent } from '@components';
import { environment } from '@environment';
import { TranslateModule } from '@ngx-translate/core';
import { AppService, MlPlayerService } from '@services';
import { SceneStore } from '@stores';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    AngularSvgIconModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    SceneLauncherComponent,
  ],
})
export class HeaderComponent {
  isSimulationView = input(false);
  showSandbox = input(false);
  showFullScreenButton = input(false);
  showHelpButton = input(false);
  showExpandSideBarButton = input(false);

  protected appService = inject(AppService);
  private mlPlayerService = inject(MlPlayerService);
  protected sceneStore = inject(SceneStore);

  environment = environment;

  fullScreen = this.appService.fullScreen;
  sandbox = environment.sandbox;
  showSideBar = this.appService.showSideBar;

  toggleFullscreen(): void {
    this.appService.fullScreen.set(!this.appService.fullScreen());
  }

  toggleSidebar(): void {
    this.appService.showSideBar.set(!this.appService.showSideBar());
  }

  selectDemoMovie(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.appService.demoMode.set(true);
      this.appService.sampleMovie.set(URL.createObjectURL(file));
    }
    (event.target as HTMLInputElement).value = '';
  }

  async selectTracking(event: Event) {
    this.appService.demoMode.set(true);
    const files = (event.target as HTMLInputElement).files;
    this.mlPlayerService.loadFiles(files);
    (event.target as HTMLInputElement).value = '';
  }

  removeDemoMovie() {
    this.setCameraId();
    this.appService.demoMode.set(false);
    this.appService.sampleMovie.set(null);
  }

  setCameraId() {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const videoInputs = devices
        .filter((device) => device.kind === 'videoinput')
        .map((device) => ({
          label: device?.label,
          id: device.deviceId,
        }))
        .reverse();
      if (videoInputs.find((camera) => camera.label === 'Back Camera')) {
        this.appService.cameraId.set(
          videoInputs.find((camera) => camera.label === 'Back Camera').id,
        );
      } else {
        this.appService.cameraId.set(videoInputs[0].id);
      }
    });
  }

  stopTrackingMode(): void {
    this.appService.trackingMode.set(false);
    this.appService.demoMode.set(false);
    this.appService.sampleMovie.set(null);
  }
}
